import { gql } from '@apollo/client';

export interface ReportsQaRow extends reports.AllReportsQueryRow {
  mapOnly: boolean | null;
}

export interface ReportsQaPageResponse {
  reports: {
    totalCount: number;
    nodes: ReportsQaRow[];
  };
}

export interface ReportsQaCountsResponse {
  needsQa: { totalCount: number };
  inProgress: { totalCount: number };
  approved: { totalCount: number };
  rejected: { totalCount: number };
  failed: { totalCount: number };
  all: { totalCount: number };
}

export const ReportsQaPageQuery = gql`
  query ReportsQaPage(
    $first: Int!
    $offset: Int!
    $orderBy: [ReportJobsOrderBy!]
    $filter: ReportJobFilter
  ) {
    reports: allReportJobs(
      first: $first
      offset: $offset
      orderBy: $orderBy
      filter: $filter
    ) {
      totalCount
      nodes {
        id
        jobId
        parentJobId
        projectName
        reportType
        targetGroupName
        requestedThrough
        startedAt
        reportStatus
        reportId
        pdfEfsUri
        clientName
        passedQa
        mapOnly
        workspaceId
        params
        producerByWorkspaceId {
          name
        }
        noOfProjectsAddedTo
      }
    }
  }
`;

export const ReportsQaCountsQuery = gql`
  query ReportsQaCounts(
    $needsQa: ReportJobFilter
    $inProgress: ReportJobFilter
    $approved: ReportJobFilter
    $rejected: ReportJobFilter
    $failed: ReportJobFilter
    $all: ReportJobFilter
  ) {
    needsQa: allReportJobs(filter: $needsQa) {
      totalCount
    }
    inProgress: allReportJobs(filter: $inProgress) {
      totalCount
    }
    approved: allReportJobs(filter: $approved) {
      totalCount
    }
    rejected: allReportJobs(filter: $rejected) {
      totalCount
    }
    failed: allReportJobs(filter: $failed) {
      totalCount
    }
    all: allReportJobs(filter: $all) {
      totalCount
    }
  }
`;
